
export const formatAmount = (amount: number, currency: string) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 0,
  });
  
  return formatter.format(amount / 100);
};

export const getFeatures = (plan: {
  product: {
    metadata: {
      features?: string;
    };
  };
}) => {
  const featuresString = plan.product.metadata.features || '';
  return featuresString.split(',').map(feature => feature.trim()).filter(Boolean);
};
